import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';
import { serializeStocktakeCreate } from '#/api/imsMgmt/receipts/stocktake/serializeStocktakeWrite';

/** POST `/ims/stocktake`。全量 lines overwrite。 */
export async function createStocktake(values) {
  const { data: raw } = await request.post(
    '/ims/stocktake',
    serializeStocktakeCreate(values),
  );
  return parseVer4DetailResponse(raw);
}
